export default {
    API_ENDPOINT: `https://mobile-bookshelf.herokuapp.com/api`,
    TOKEN_KEY: 'mobile-bookshelf-auth-token',
    USER_NAME: 'mobile-bookshelf-user-name'
  }